module.exports = __webpack_public_path__ + "static/media/0604.b4c2b8ff.png";